export default __webpack_public_path__ + "c8e460aadd4d054318682f9d906cfe7b.png";